import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap';


class ButtonsToevoegen extends Component {
    render() {
        return (
            <div>
                <Row>
                    <Col md={4} sm={4}>
                        <div>
                            <LinkContainer to="/kennis/bijeenkomst/toevoegen"><Button bsSize="large" block>Bijeenkomst</Button></LinkContainer>
                            <LinkContainer to="/kennis/cursus/toevoegen"><Button bsSize="large" block>Cursus</Button></LinkContainer>
                            <LinkContainer to="/kennis/docentschap/kiezen"><Button bsSize="large" block>Docentschap</Button></LinkContainer>
                        </div>
                    </Col>
                    <Col md={4} sm={4}>
                        <div>
                            <LinkContainer to="/kennis/incompany-cursus/toevoegen"><Button bsSize="large" block>Incompany cursus</Button></LinkContainer>
                            <LinkContainer to="/kennis/incompany-kennisoverdracht/toevoegen"><Button bsSize="large" block>Incompany kennisoverdracht</Button></LinkContainer>
                            <LinkContainer to="/kennis/lidmaatschap/kiezen"><Button bsSize="large" block>Lidmaatschap</Button></LinkContainer>
                        </div>
                    </Col>
                    <Col md={4} sm={4}>
                        <div>
                            <LinkContainer to="/kennis/opleiding/toevoegen"><Button bsSize="large" block>Opleidingen</Button></LinkContainer>
                            <LinkContainer to="/kennis/publicaties/toevoegen"><Button bsSize="large" block>Publicatie</Button></LinkContainer>
                            <LinkContainer to="/kennis/voordracht/toevoegen"><Button bsSize="large" block>Voordracht</Button></LinkContainer>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default ButtonsToevoegen;



// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/AddButtons.js